var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notfound-page"},[_c('img',{attrs:{"src":require("@/assets/img/404.jpg"),"alt":"找不到页面"}}),_c('p',{staticClass:"sorry"},[_vm._v("咦~页面不见了~")])])
}]

export { render, staticRenderFns }